import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IQService, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {OtpOppsettRessurs} from "../../../../../felles/tjenester/ressurser/OtpOppsettRessurs";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {BrukerRessurs} from "../../../../../felles/tjenester/ressurser/BrukerRessurs";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {Debugger} from "debug";
import {ReautentiseringDialogKontroller} from "../../modale/reautentisering/reautentisering";

const debuger = require('debug');
const debug:Debugger = debuger('AktiverSmsOtpKontroller');

const css = require('./aktiverSmsOtp.scss');

export class AktiverSmsOtpKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerAktiverSmsOtp', {
              bindings: {
                  vedFerdig: '&',
                  vedAvbryt: '&'
              },
              controller: AktiverSmsOtpKontroller.forInjisering(),
              template: require('./aktiverSmsOtp.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.md.$mdDialog,
            OtpOppsettRessurs.regNavn,
            BrukerRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            Kontekst.regNavn,
            AktiverSmsOtpKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $mdDialog: angular.material.IDialogService,
                private otpOppsettRessurs: OtpOppsettRessurs,
                private brukerRes: BrukerRessurs,
                private gettextCatalog: gettextCatalog,
                private kontekst: Kontekst) {
    }

    vedFerdig: Function; //settes via bindings
    vedAvbryt: Function; //settes via bindings

    lagrer = false;
    mobilnummer: string;
    reservekoder: l.SmsOtpReservekoderModell;

    steg: 'angi' | 'bekreft' | 'kvittering' = 'angi';

    oppdaterMobilnummer() {
        this.lagrer = true;
        ReautentiseringDialogKontroller.visReautentiseringDialog(
            this.gettextCatalog.getString('Bekreft identiteten din for å lagre mobilnummer'),
            autentiseringsinfo => this.validerPassordOgOppdaterMobilnummer(autentiseringsinfo),
            this.$mdDialog)
            .finally(() => this.lagrer = false);
    }

    mobilnummerBekreftet(){
        this.aktiver();
    }

    lukk() {
       this.vedFerdig();
    }

    avbryt() {
       this.vedAvbryt();
    }

    $onInit(): void {
        debug("$onInit", this.kontekst.autentisertBruker(), this.kontekst.autentisertBruker().mobilnummerErBekreftet, !_.isNil(this.kontekst.autentisertBruker().mobilnummer))
        if (this.kontekst.autentisertBruker().mobilnummerErBekreftet)
            return this.aktiver();

        if (!_.isNil(this.kontekst.autentisertBruker().mobilnummer))
            return this.gåTilBekreftSteg();

        this.gåTilAngiSteg();
    }

    // hjelpemetoder

    private validerPassordOgOppdaterMobilnummer(autentiseringsinfo: l.Reautentiseringsinformasjon) {
        const spesifikasjon:l.OppdaterBrukerSensitivSpesifikasjon = {
            id: this.kontekst.autentisertBruker().id,
            epost: this.kontekst.autentisertBruker().epost,
            brukernavn: this.kontekst.autentisertBruker().brukernavn,
            mobilnummer: this.mobilnummer,
            autentiseringsinfo: autentiseringsinfo,
        }

        return this.brukerRes.oppdaterSensitiveData(spesifikasjon).$promise
            .then((oppdateringsResultat: l.OppdatertSensitiveDataModell) => {
                if (oppdateringsResultat.autentiseringOk) {
                    this.kontekst.relastBruker();
                    if (oppdateringsResultat.mobilnummerKreverValidering) this.gåTilBekreftSteg();
                } else {
                    debug("Autentisering feilet")
                }
                return oppdateringsResultat.autentiseringOk;
            });
    }

    private aktiver(){
        this.lagrer = true;
        this.otpOppsettRessurs.aktiverSms().$promise
            .then(reservekoder => {
                this.reservekoder = reservekoder;
                this.kontekst.relastBruker();
                this.gåTilVisKvittering();
            })
            .finally(() => this.lagrer = false);
    }

    private gåTilAngiSteg(){
        this.steg = 'angi';
    }

    private gåTilBekreftSteg(){
        this.steg = 'bekreft';
    }

    private gåTilVisKvittering(){
        this.steg = 'kvittering';
    }
}
